<template>
    <div style="background: #f1eff0;min-height: 100vh;padding-bottom: 30px;">
        <div class="top-box top-bg">
            <div class="td-container td-fbc">
                <img class="logo" :src="GLOBAL.Images.logo_white" @click="$router.push('/')">
                <div class="right">
                    <div @click="$router.push('/parent')">
                        <img v-if="parentInfo.avatar" :src="parentInfo.avatar">
                        <img v-else :src="GLOBAL.Images.avatar">
                        <div>{{parentInfo.realname ? parentInfo.realname : parentInfo.emp_no}}</div>
                    </div>
                    <div @click="signOut">
                        <img src="../../assets/img/teacher/switch.png" alt="">
                        <div>退出</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="m-star-box">
            <div class="td-fbc">
                <div class="title">我的订阅：</div>
                <div class="star-list td-fsc td-f1">
                    <div class="star-item" v-for="(item) in routerArr" :class="{'active-tab': $route.meta.subType == item.path}" @click="goUrl(item)" :key="item.path">
                        <img :src="item.imgUrl" alt="">
                        <div>{{item.name}}</div>
                    </div>
                </div>
            </div>
            <div class="td-fbc">
                <div class="title">我的学员：</div>
                <div class="star-list td-fsc td-f1">
                    <div class="star-item" v-for="(item,index) in studentList" :class="{'active-tab': $route.query.student_id == item.id}" @click="goStudentInfo(item)" :key="index"v-if="index < 4">
                        <img src="../../assets/img/parents/people.png" alt="">
                        <div>{{item.student_name || item.emp_no}}</div>
                    </div>
                </div>
                <div class="see-more" @click="dialogStudentList=true" v-if="studentList.length > 3">更多学员</div>
            </div>
        </div>
        <div class="td-container content">
            <div class="left-box">
                <div class="user td-fcc td-fc">
                    <img v-if="parentInfo.avatar" :src="parentInfo.avatar">
                    <img v-else :src="GLOBAL.Images.avatar">
                    <div class="name">{{parentInfo.realname ? parentInfo.realname : parentInfo.emp_no}}</div>
                    <div class="user-btn td-fcc btn-color" @click="$router.push('/parent')">
                        <img src="../../assets/img/teacher/people_icon.png" alt="">
                        <div>个人信息</div>
                    </div>
                </div>
                <div class="star-box">
                    <div class="title">
                        <div>我的订阅</div>
                    </div>
                    <div class="star-list">
                        <div class="star-item" v-for="(item) in routerArr" :class="{'active-tab': $route.meta.subType == item.path}" @click="goUrl(item)" :key="item.path"> 
                            <img :src="item.imgUrl" alt="">
                            <div>{{item.name}}</div>
                        </div>
                    </div>
                </div>
                <div class="star-box">
                    <div class="title">
                        <div>学员列表</div>
                    </div>
                    <div class="star-list">
                        <div class="star-item" v-for="(item,index) in studentList" :class="{'active-tab': $route.query.student_id == item.id}" @click="goStudentInfo(item)" :key="index" >
                            <img src="../../assets/img/parents/people.png" alt="">
                            <div>{{item.student_name || item.emp_no}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right-box">
                <router-view></router-view>
            </div>
        </div>
        <!-- 移动端 更多学生 -->
        <el-dialog class="el-dialog-com m-more-box" title="我的学员" :visible.sync="dialogStudentList">
            <div class="dislog-box">
                <div class="star-list td-f">
                    <div class="star-item" v-for="(item,index) in studentList" :class="{'active-tab': $route.query.student_id == item.id}" @click="goStudentInfo(item)" :key="index">
                        <img src="../../assets/img/parents/people.png" alt="">
                        <div>{{item.student_name || item.emp_no}}</div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Lockr from "lockr";
import { mapGetters } from "vuex";
import {
    parentInfo
} from '@/api/parent'

export default {
    name: "parentsIndex",
    computed: {
        ...mapGetters(["parentInfo"])
    },
    data() {
        return {
            dialogStudentList: false,
            routerArr: [{
                    name: '添加成员',
                    path: 'addStudent',
                    imgUrl: require('../../assets/img/parents/left_menu.png'),
                },
                {
                    name: '解绑学员',
                    path: 'removeStudent',
                    imgUrl: require('../../assets/img/parents/left_menu2.png'),
                },
                {
                    name: '竞赛排行',
                    path: 'ranking',
                    imgUrl: require('../../assets/img/parents/left_menu3.png'),
                },

            ],
            studentList: [],
            whitelist: ['addStudent','removeStudent','ranking','studentInfo']
        };
    },
    methods: {
        // 路由跳转
        goUrl(item) {
            if (this.whitelist.indexOf(this.$route.meta.subType) > -1 ) {
                this.$router.replace('/parent/'+item.path)
            } else {
                this.$router.push('/parent/'+item.path)
            }
        },
        // 学员详情
        goStudentInfo(item) {
            this.dialogStudentList = false
            if (item.id != this.$route.query.student_id) {
                this.$router.push(`/parent/studentInfo?student_id=${item.id}`)
            }
        },
        // 获取学员列表
        async getStudentList() {
            let params = {
                token: Lockr.get('parentToken')
            }
            let result = await parentInfo(params)
            if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                this.studentList = result.data.student_list || []
            } else {
                this.$message({
                    message: result.msg,
                    type: 'warning'
                });
            }
        },
        //退出
        signOut() {
            this.$confirm('您将要退出当前账户？', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$store
                    .dispatch("ParentLogout", {})
                    .then(res => {
                        this.$router.replace("/");
                    })
                    .catch(err => {
                        this.$message.error({
                            message: err.msg,
                            duration: "2000"
                        });
                    });
            }).catch(() => {});
        }
    },
    created() {
        this.getStudentList()
    },
}
</script>

<style scoped lang='less'>
@import "../../assets/css/user";
.top-bg{
    background-color: #2FA59A;
}
.btn-color{
    background: #2FA59A;
}
.text-color{
    color: #2FA59A;
}
.see-more{
    font-size: 14px;
    color: #2FA59A;
    padding-left:20px;
    padding-right:10px;
    border-left: solid #eee 1px;
}
</style>